module.exports = __webpack_public_path__ + "media/assets/images/logo-0b59249628318d5c6002c708a355221c.png";